export default function mixin(...args) {
  var ParentClass = args.pop();
  var classGenerators = args;
  return classGenerators.reduce((ParentClass, classGenerator) => {
    return classGenerator(ParentClass);
  }, ParentClass);
}



// WEBPACK FOOTER //
// ./src/js/Util/mixin.js